import Quagga from '@ericblade/quagga2';

let scannerInitialized = false;
let scannerRunning = false;

const selectors = {
    inputENumber: '#office-e-number',
    inputLagerle: '#office-lagerle',
    openBtnENumber: '#open-scanner-btn-office-e-number',
    openBtnLagerle: '#open-scanner-btn-office-lagerle',
    closeBtn: '#close-scanner-btn',
    stopBtn: '#stop-scanner-btn',
    modal: '#scanner-modal',
    preview: '#scanner-preview',
    status: '#scanner-status',
};

function $(selector) {
    return document.querySelector(selector);
}

function setStatus(message, isError = false) {
    const el = $(selectors.status);
    if (!el) return;

    el.textContent = message;
    el.className = isError
        ? 'mt-3 text-sm text-red-600'
        : 'mt-3 text-sm text-gray-600';
}

function openModal() {
    const modal = $(selectors.modal);
    if (!modal) return;

    modal.classList.remove('hidden');
    modal.classList.add('flex');
}

function closeModal() {
    const modal = $(selectors.modal);
    if (!modal) return;

    modal.classList.add('hidden');
    modal.classList.remove('flex');
}

function cleanupPreview() {
    const preview = $(selectors.preview);
    if (!preview) return;

    preview.innerHTML = '';
}

function onDetected(result) {
    const code = result?.codeResult?.code;

    if (!code) return;

    if (code.startsWith('P') || code.startsWith('R')) {
        const input = $(selectors.inputLagerle);
        input.value = code;
        input.dispatchEvent(new Event('input', {bubbles: true}));
        input.dispatchEvent(new Event('change', {bubbles: true}));

    } else if (code.startsWith('E')) {
        const input = $(selectors.inputENumber);
        input.value = code;
        input.dispatchEvent(new Event('input', {bubbles: true}));
        input.dispatchEvent(new Event('change', {bubbles: true}));
    }

    setStatus(`Barcode erkannt: ${code}`);
    stopScanner();
    closeModal();
}

function onProcessed(result) {
    // Optional: Debug-Overlay könnte hier gezeichnet werden.
    // Für ein robustes, schlankes Mobile-Setup lassen wir es bewusst weg.
}

function initScanner() {
    return new Promise((resolve, reject) => {
        const preview = $(selectors.preview);

        if (!preview) {
            reject(new Error('Scanner-Preview-Element nicht gefunden.'));
            return;
        }

        cleanupPreview();

        Quagga.init(
            {
                inputStream: {
                    name: 'Live',
                    type: 'LiveStream',
                    target: preview,
                    constraints: {
                        facingMode: 'environment',
                        width: {ideal: 1280},
                        height: {ideal: 720},
                    },
                    area: {
                        top: '20%',
                        right: '5%',
                        left: '5%',
                        bottom: '20%',
                    },
                },
                locator: {
                    patchSize: 'medium',
                    halfSample: true,
                },
                numOfWorkers: navigator.hardwareConcurrency
                    ? Math.min(navigator.hardwareConcurrency, 4)
                    : 2,
                locate: true,
                decoder: {
                    readers: ['code_128_reader'],
                    multiple: false,
                },
                frequency: 10,
            },
            (err) => {
                if (err) {
                    reject(err);
                    return;
                }

                scannerInitialized = true;
                resolve();
            }
        );
    });
}

async function startScanner() {
    if (scannerRunning) return;

    openModal();
    setStatus('Bitte Kamerazugriff erlauben und den Barcode vor die Kamera halten.');

    try {
        if (!scannerInitialized) {
            await initScanner();
        }

        Quagga.offDetected(onDetected);
        Quagga.offProcessed(onProcessed);

        Quagga.onDetected(onDetected);
        Quagga.onProcessed(onProcessed);

        Quagga.start();
        scannerRunning = true;

        setStatus('Scanner läuft. Bitte GS1-128 / Code 128 in den markierten Bereich halten.');
    } catch (error) {
        console.error('Quagga2 konnte nicht initialisiert werden:', error);
        setStatus(
            'Kamera konnte nicht gestartet werden. Bitte HTTPS, Safari-Kameraberechtigung und Rückkamera prüfen.',
            true
        );
        closeModal();
    }
}

function stopScanner() {
    if (scannerRunning) {
        Quagga.stop();
        scannerRunning = false;
    }

    Quagga.offDetected(onDetected);
    Quagga.offProcessed(onProcessed);

    scannerInitialized = false;
    cleanupPreview();
}

function bindScannerEvents() {
    const openBtn = $(selectors.openBtnLagerle);
    const closeBtn = $(selectors.closeBtn);
    const stopBtn = $(selectors.stopBtn);
    const modal = $(selectors.modal);

    if (!openBtn || !closeBtn || !stopBtn || !modal) return;

    $(selectors.openBtnENumber).addEventListener('click', () => {
        startScanner();
    });
    $(selectors.openBtnLagerle).addEventListener('click', () => {
        startScanner();
    });

    closeBtn.addEventListener('click', () => {
        stopScanner();
        closeModal();
    });

    stopBtn.addEventListener('click', () => {
        stopScanner();
        closeModal();
    });

    modal.addEventListener('click', (event) => {
        if (event.target === modal) {
            stopScanner();
            closeModal();
        }
    });

    document.addEventListener('visibilitychange', () => {
        if (document.hidden && scannerRunning) {
            stopScanner();
            closeModal();
        }
    });
}

document.addEventListener('DOMContentLoaded', bindScannerEvents);
